import { createStyles, mapColorNameAndIndexToValue, rem } from '@affstore-ds/uikit'

import { mapLevelNameToColors } from './utils/mapLevelNameToColors'

export const useLevelBadgeStyles = createStyles((theme, { levelName }: { levelName?: string }) => {
  const [textColorValue, backgroundColorValue] = mapLevelNameToColors(levelName)
  const textColor = mapColorNameAndIndexToValue(theme.other.colors, textColorValue)

  return {
    root: {
      boxShadow: `0px 6px 10px 0px rgba(255, 255, 255, 0.80) inset`,
      backgroundColor: backgroundColorValue,
      borderRadius: rem(100),
      cursor: 'pointer',
    },
    label: {
      color: textColor,
    },
  }
})
